// src/constants/vendorCategories.js
export const VENDOR_CATEGORIES = [
    "Interior Products",
    "Interiors / Design & Fitouts",
    "Event Management",
    "Technicians",
    "Home Appliances",
    "Daily Needs",
    "Maids & Cooks",
  ];